import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';

// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/bell-o-2.json)
// Used for NEW navigation
const bellO2IconData = {
	icon: {
		attrs: [{}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M565.485 907.667c13.046-18.021 37.898-23.574 57.557-12.173 20.96 12.163 28.099 39.010 15.946 59.974l-2.331 3.875c-11.942 19.117-28.419 35.035-48.008 46.31l-0.018-0.018c-20.869 12.018-44.525 18.363-68.616 18.363-24.096-0.002-47.762-6.341-68.634-18.363-19.576-11.272-36.062-27.173-48.008-46.293l-2.314-3.875-2.058-3.994c-9.157-20.272-1.653-44.579 18.003-55.981 19.659-11.402 44.491-5.846 57.539 12.173l2.435 3.773 1.731 2.76c3.627 5.403 8.288 10.038 13.699 13.648l2.778 1.715 2.882 1.542c6.816 3.354 14.325 5.109 21.946 5.109 8.71 0 17.274-2.285 24.827-6.635l0.018-0.016 2.76-1.715c6.312-4.208 11.603-9.811 15.43-16.408l2.435-3.773z',
			'M520.014 0c87.090 0 169.998 36.936 230.659 101.639l5.589 6.121c57.042 63.93 88.555 148.364 88.557 235.768 0 168.77 33.861 274.146 65.411 335.846 15.814 30.928 31.251 51.275 42.022 63.405 5.394 6.070 9.662 10.12 12.259 12.43 1.29 1.146 2.179 1.867 2.59 2.195 0.128 0.101 0.21 0.178 0.24 0.205l-0.309-0.24-0.104-0.069c15.482 11.082 22.061 30.89 16.272 49.037-5.81 18.192-22.72 30.554-41.818 30.554h-842.738c-19.096-0.003-36.009-12.363-41.818-30.554-5.426-17.013 0.018-35.488 13.476-46.859l2.383-1.869c0.024-0.024 0.103-0.096 0.24-0.205 0.408-0.325 1.293-1.043 2.589-2.195 2.597-2.309 6.863-6.355 12.259-12.43 10.772-12.128 26.206-32.472 42.024-63.405 31.551-61.701 65.41-167.074 65.41-335.846 0.003-90.224 33.579-177.282 94.146-241.889l5.762-5.984c60.094-60.991 140.531-95.653 224.898-95.655zM520.014 87.785c-59.981 0.001-118.168 24.601-162.386 69.491l-4.235 4.407c-44.784 47.773-70.397 113.142-70.398 181.845 0 180.803-36.37 300.179-75.046 375.813-5.544 10.842-11.165 20.728-16.666 29.765h657.462c-5.499-9.035-11.122-18.926-16.666-29.765-38.675-75.635-75.045-195.013-75.045-375.813-0.003-68.704-25.613-134.074-70.4-181.845-44.699-47.678-104.709-73.898-166.621-73.898z',
		],
		tags: ['bell'],
	},
	attrs: [{}, {}],
	properties: {
		code: 59758,
		id: 5,
		name: 'bell-o-2',
		order: 3429,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 8,
};

// Create IconBuilder from cond-ui-kit data
const NotificationsIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	bellO2IconData as any,
	'#89c32e', // Default green color for new navigation
);

export default NotificationsIconBuilder;
